import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Investors\CreditController::__invoke
* @see app/Http/Controllers/Investors/CreditController.php:35
* @route '//app.finesthub.de/credit'
*/
const CreditController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: CreditController.url(options),
    method: 'get',
})

CreditController.definition = {
    methods: ["get","head"],
    url: '//app.finesthub.de/credit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Investors\CreditController::__invoke
* @see app/Http/Controllers/Investors/CreditController.php:35
* @route '//app.finesthub.de/credit'
*/
CreditController.url = (options?: RouteQueryOptions) => {
    return CreditController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\CreditController::__invoke
* @see app/Http/Controllers/Investors/CreditController.php:35
* @route '//app.finesthub.de/credit'
*/
CreditController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: CreditController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Investors\CreditController::__invoke
* @see app/Http/Controllers/Investors/CreditController.php:35
* @route '//app.finesthub.de/credit'
*/
CreditController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: CreditController.url(options),
    method: 'head',
})

export default CreditController